export const UNKNOWN_TARGET = 10;

export type PostPlan = { word: string; quality: 5 | 1 };

export function planPagePosts(input: {
  pageEntries: { word: string }[];
  selectedOnPage: ReadonlySet<string>;
}): PostPlan[] {
  return input.pageEntries.map((e) => ({
    word: e.word,
    quality: input.selectedOnPage.has(e.word) ? 1 : 5,
  }));
}

export function appendUnknowns(
  acc: readonly string[],
  newlyUnknown: readonly string[],
): string[] {
  const seen = new Set(acc);
  const out = [...acc];
  for (const w of newlyUnknown) {
    if (!seen.has(w)) {
      seen.add(w);
      out.push(w);
    }
  }
  return out;
}

export type Decision =
  | { kind: 'continue' }
  | { kind: 'learn'; words: string[] }
  | { kind: 'done' };

export function decideNextPhase(input: {
  unknownAccumulated: readonly string[];
  remainingPool: number;
  nextRoundPicksLength: number;
}): Decision {
  if (input.unknownAccumulated.length >= UNKNOWN_TARGET) {
    return { kind: 'learn', words: [...input.unknownAccumulated] };
  }
  if (input.remainingPool === 0 || input.nextRoundPicksLength === 0) {
    if (input.unknownAccumulated.length === 0) return { kind: 'done' };
    return { kind: 'learn', words: [...input.unknownAccumulated] };
  }
  return { kind: 'continue' };
}
